import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="container-saksham py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6">
              <div className="h-16 md:h-20 w-60 md:w-72 overflow-hidden flex items-center justify-center">
                <img
                  src="/saksham-logo-dark.png"
                  alt="Saksham — Empowering Micropreneurs"
                  className="h-[170px] md:h-[200px] w-auto select-none"
                  draggable={false}
                />
              </div>
            </div>
            <p className="font-serif text-2xl md:text-3xl leading-snug text-white/85 max-w-md">
              Bridging the gap between <em className="text-[#FBD223] not-italic">ambition</em> and <em className="text-[#09B792] not-italic">achievement</em>.
            </p>
            <p className="mt-6 text-sm text-white/55 max-w-md">
              A non-profit working alongside 12 million women-owned enterprises across India.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.25em] text-[#09B792] font-semibold mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/blogs" data-testid="footer-link-blogs" className="text-white/80 hover:text-[#FBD223] transition-colors">Blogs</Link>
              </li>
              <li>
                <Link to="/faqs" data-testid="footer-link-faqs" className="text-white/80 hover:text-[#FBD223] transition-colors">FAQs</Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-white/80 hover:text-[#FBD223] transition-colors">Contact Us</Link>
              </li>
              <li>
                <Link to="/what-we-do" data-testid="footer-link-what" className="text-white/80 hover:text-[#FBD223] transition-colors">What We Do</Link>
              </li>
              <li>
                <Link to="/our-impact" data-testid="footer-link-impact" className="text-white/80 hover:text-[#FBD223] transition-colors">Our Impact</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[10px] uppercase tracking-[0.25em] text-[#09B792] font-semibold mb-5">Follow Us</h4>
            <a
              href="https://www.linkedin.com/company/saksham009/"
              data-testid="footer-linkedin"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 group"
            >
              <span className="w-12 h-12 border border-white/15 group-hover:border-[#FBD223] flex items-center justify-center transition-colors">
                <Linkedin size={18} className="group-hover:text-[#FBD223] transition-colors" />
              </span>
              <span className="text-sm">
                <span className="block text-white">LinkedIn</span>
                <span className="block text-white/50 group-hover:text-white/80 transition-colors flex items-center gap-1">
                  Follow our journey <ArrowUpRight size={14} />
                </span>
              </span>
            </a>

            <div className="mt-10 pt-8 border-t border-white/10">
              <p className="text-xs text-white/45 leading-relaxed">
                Saksham works toward SDG 5, 8, 9 and 10 — gender equality, decent work, innovation and reduced inequalities.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Saksham. All rights reserved.</p>
          <p className="text-xs text-white/40 font-serif italic">Driving inclusive growth by democratising success.</p>
        </div>
      </div>
    </footer>
  );
}
